import {Component, Input} from '@angular/core';
import {ThingFeatureLoopInterface} from '@app/app/shared/interfaces/thing/thing-feature-loop.interface';

@Component({
  templateUrl: './park-filtration-loop-controls.html',
  selector: 'park-filtration-loop-controls'
})

export class ParkFiltrationLoopControlsComponent {
  @Input() public filtrationloops: ThingFeatureLoopInterface[];
  @Input() public parkId: any;
  @Input() public id: any;
  @Input() public color: string;

  objectKeys = Object.keys;

  public elements(el) {
    return Object.keys(el).filter((eId: any) => {
      return !el[eId].hasOwnProperty('sensortype') || !['WD', 'AN', 'DP', 'WT'].includes(el[eId].sensortype.toUpperCase());
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/filtration/filtration-loop/park-filtration-loop-controls.component.ts